import { isImmutable, List, Map } from 'immutable'
import _ from 'lodash'

const getDocumentPath = (state) =>
  state.getIn(['sign', 'document', '_id']) ? ['sign', 'document'] : ['prepare', 'document']

const formatLabel = (elem) => {
  if (elem.getIn(['props', 'tag'], '')) {
    return `[${elem.getIn(['props', 'tag'], '')}]`
  } else if (elem.getIn(['props', 'label'])) {
    return elem.getIn(['props', 'label'])
  } else {
    return String(elem.get('type')).replace('Input:', '').replace('Output:', '')
  }
}

let prevMapping = null
let resultsMapping = null
export const getProjectMappingElements = (state, isInCondition = false, activeStep, isForce) => {
  if (isForce) {
    return _getProjectMappingElements(state, isInCondition, activeStep)
  }
  if (prevMapping === null || resultsMapping === null || Date.now() - prevMapping > 1000) {
    prevMapping = Date.now()
    resultsMapping = _getProjectMappingElements(state, isInCondition, activeStep)
  }
  return resultsMapping
}

export const _getProjectMappingElements = (state, isInCondition = false, activeStep) => {
  let ret = []

  const path = getDocumentPath(state)

  let pagesElements = state.getIn([...path, 'Settings', 'pages'], Map())

  pagesElements.map((page) => {
    page.map((elem) => {
      ret.push({
        value: elem.get('id'),
        label: formatLabel(elem),
        group: 'elem',
      })
    })
  })
  return ret
}

export const getVarHash = (state) => {
  let list = []
  state.getIn(['project', 'Settings', 'params'], List()).map((param) => {
    list.push(`${param.get('id')}-${param.get('name')}`)
  })
  state.getIn(['pages', state.get('page'), 'Props', 'params'], List()).map((param) => {
    list.push(`${param.get('id')}-${param.get('name')}`)
  })
  return list.join('##')
}

let prev = null
let results = null
let varHash = null
export const getConditionsActionTargetCache = (state, isExport = false, type = null) => {
  if (prev === null || results === null || Date.now() - prev > 1000 || varHash !== getVarHash(state)) {
    prev = Date.now()
    results = getConditionsActionTarget(state, isExport, type)
    varHash === getVarHash(state)
  }
  return results
}

export const getConditionsActionTarget = (state) => {
  let ret = []

  const path = getDocumentPath(state)

  let pagesElements = state.getIn([...path, 'Settings', 'pages'], Map())

  pagesElements.map((page) => {
    page.map((elem) => {
      ret.push({
        value: elem.get('id'),
        uid: elem.get('id'),
        text: formatLabel(elem),
        type: 'elem',
      })
    })
  })

  return ret
}

export const getConditionUsage = (state) => {
  const whereUsed = []
  const affectedBy = []
  const selectedField = state.getIn(['prepare', 'selected', 0], null)

  if (!selectedField && !isImmutable(selectedField)) {
    return {
      whereUsed,
      affectedBy,
    }
  }

  const selectedID = selectedField.get('id')

  let pagesElements = state.getIn(['prepare', 'document', 'Settings', 'pages'], Map())

  pagesElements.map((page, pageIndex) => {
    page.map((elem, elemIndex) => {
      if (elem.get('rules', List()).size > 0) {
        elem.get('rules', List()).map((rule, index) => {
          rule.get('conditions', List()).map((cond) => {
            let fieldID = cond.getIn(['field', 'value'])
            if (fieldID === selectedID) {
              whereUsed.push({
                label: `${formatLabel(elem)} / Condition #${index + 1} `,
                path: [pageIndex, elemIndex, 'rules'],
              })
            }
            if (cond.get('valueType') === 'field') {
              let valueFiledID = cond.getIn(['value', 'value'])
              if (valueFiledID === selectedID) {
                whereUsed.push({
                  label: `${formatLabel(elem)} / Condition #${index + 1} `,
                  path: [pageIndex, elemIndex, 'rules'],
                })
              }
            }
          })
          rule.get('actions', Map()).map((actions, key) => {
            actions.map((action) => {
              if (key === selectedID) {
                affectedBy.push({
                  label: `${formatLabel(elem)} / Condition #${index + 1} / ${action.get('type')}`,
                  path: [pageIndex, elemIndex, 'rules'],
                })
              }
            })
          })
        })
      }
    })
  })

  return {
    whereUsed,
    affectedBy,
  }
}
/**
 * Creates a debounced Redux action dispatcher that accumulates parameters and dispatches them in a batch
 * after a specified delay. It helps prevent excessive dispatches by combining multiple calls within the
 * debounce window into one action. Useful for handling frequent actions efficiently.
 */
export const createDebouncedAction = (actionType, debounceDelay = 10) => {
  let paramsList = []

  const debouncedDispatch = _.debounce((dispatch) => {
    dispatch({
      type: actionType,
      payload: paramsList,
    })

    paramsList = []
  }, debounceDelay)

  return (...params) =>
    (dispatch) => {
      paramsList.push([...params])

      debouncedDispatch(dispatch)
    }
}

const openIndexedDB = async (dbName, storeName) => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(dbName)

    request.onupgradeneeded = (event) => {
      const db = event.target?.result
      if (!db?.objectStoreNames.contains(storeName)) {
        db.createObjectStore(storeName)
      }
    }
    request.onsuccess = (event) => resolve(event.target?.result)
    request.onerror = (event) => reject(event.target?.error)
  })
}

export const getFromIndexedDb = async (key, storeName, dbName) => {
  const db = await openIndexedDB(dbName, storeName)
  return new Promise((resolve, reject) => {
    const tx = db.transaction(storeName, 'readonly')
    const store = tx.objectStore(storeName)
    const request = store.get(key)
    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error)
  })
}

export const getPushToken = async (projectId) => {
  const STORE_NAME = 'keys'
  const RECORDS = {
    VAPID_TOKEN: 'vapidToken',
  }
  // Use project-specific database name if projectId is provided, otherwise fallback to old name for backward compatibility
  const DB_NAME = projectId ? `pushDB-${projectId}` : 'pushDB'
  return getFromIndexedDb(RECORDS.VAPID_TOKEN, STORE_NAME, DB_NAME)
}
